import React, {useState, useEffect} from 'react';
import Nav from 'react-bootstrap/Nav';
import { FaComments, FaEdit, FaInfo, FaBook, FaClipboard, FaLink, FaRegImage} from 'react-icons/fa';
import { goToGitHubEdit, copyToClipboard } from '../utils';
import { Surface3 } from '../Surface3';
import { Surface3Wrapper } from '../Surface3Wrapper';
import { Citation } from '../Citation/Citation';
import { Comments } from '../Comments/Comments';

interface MyComponentProps{
  handleChangeInfo?: any;
  handleChangeDictInfo?: any;
  id: string;
  info: any;
  selectedTextRange: any;
  selectedText: string;
}

export const ToolTipContent: React.FC<MyComponentProps> = ({handleChangeInfo,handleChangeDictInfo,selectedText,info, id, selectedTextRange}) => {
  //old params handleChangeInfo, info, id, selectedTextRange,selectedText
  const [showImage, setShowImage] = useState(false)
  const [showCitation, setShowCitation] = useState(false)
  const [showComments, setShowComments] = useState(false)
  const tresourceid = id
  const tresourceidBlock = id?.split("@")[0]
  const lastSlashIndex = tresourceidBlock?.lastIndexOf('/');
  const mid = tresourceidBlock?.substring(0, lastSlashIndex);
  const eid = "http://scta.info/resource/" + mid.split("/resource/")[1].split("/")[0]
  const selectionRange = {wordRange: selectedTextRange, text: selectedText}
  //const selectedTextRange: any = {wordRange: {start: startWord, end: endWord}, text: ""}

  console.log("selectionRange", selectionRange)
  console.log("selectionRangeLength", selectionRange.text.split(" ").length)
  return (
    <div style={{maxWidth: "500px", overflow: "scroll", maxHeight: "500px"}}>
      <Nav>
        <Nav.Link onClick={() => handleChangeInfo(id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end)}><FaInfo /></Nav.Link>
        <Nav.Link onClick={() => {
          setShowComments(!showComments)
        }}><FaComments /></Nav.Link>
        <Nav.Link onClick={() => { goToGitHubEdit(
          tresourceidBlock || "", 
          selectedText.split(" ")[0] || "", 
          tresourceid?.split("/resource/")[1]?.split("/")[0] || "") }}>
            <FaEdit /></Nav.Link>
        {/* <Nav.Link><FaSearch /></Nav.Link>
        <Nav.Link><FaBook /></Nav.Link> */}
        <Nav.Link onClick={() => {
          // copyToClipboard(id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end);
          copyToClipboard(eid + "@" + selectedTextRange.start + '-' + selectedTextRange.end);
          setShowCitation(!showCitation)
        }}><FaClipboard /></Nav.Link>
        <Nav.Link onClick={() => {
          // copyToClipboard(id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end);
          copyToClipboard("https://scta.lombardpress.org/res?resourceid=" + id + (info?.focusInfo?.mtFocus || "") + "@" + selectedTextRange.start + '-' + selectedTextRange.end);
          setShowCitation(!showCitation)
        }}><FaLink /></Nav.Link>
        <Nav.Link><FaRegImage onClick={() => setShowImage(!showImage)}/></Nav.Link>
        {
        (selectionRange?.text?.split(" ").length === 1) 
          && <Nav.Link><FaBook onClick={() => handleChangeDictInfo(selectionRange.text)}/></Nav.Link>
        }
        
      </Nav>
      {showImage && <Surface3 manifestationid={mid} startWord={selectedTextRange.start} endWord={selectedTextRange.end} width={500}/>}
      {showImage && <Surface3Wrapper 
      expressionid={eid} 
      focusedmanifestation={mid} 
      startWord={selectedTextRange.start} 
      endWord={selectedTextRange.end}
      hideCustomImageForm={true}
      width={500}
      hideDisplayChoice={true}
      />}
      {showCitation && <Citation tresourceid={tresourceidBlock} citationStyle="minimal" showGitHubEdit={false} selectionRange={selectedTextRange}/>}
      {showComments && <Comments resourceid={tresourceidBlock} expressionid={eid} selectionRange={selectionRange} handleOnClickComment={handleChangeInfo} />}
    </div>
  );
};
